import { END_USER_MOBILE_FRAME_WIDTH_PX } from 'constants/endUserMobileLayout';

import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

import { colors } from 'theme/colors';

type SurfaceProps = { $whiteSurface?: boolean };

const surfaceBackground = ({ $whiteSurface }: SurfaceProps): string =>
  $whiteSurface === true ? colors.background.main : colors.subtle.dark;

/** Full onboarding frame. `$whiteSurface` removes grey bands (Find Expenses connect only). */
export const OnboardingShell = styled(Box, {
  shouldForwardProp: prop => prop !== '$whiteSurface',
})<SurfaceProps>`
  width: 100%;
  min-height: 100vh;
  max-width: ${END_USER_MOBILE_FRAME_WIDTH_PX}px;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  background-color: ${surfaceBackground};
`;

/** Chrome around the onboarding stepper + shared Spence logo. */
export const OnboardingChrome = styled(Box, {
  shouldForwardProp: prop => prop !== '$whiteSurface',
})<SurfaceProps>`
  padding: 20px 16px 16px;
  flex-shrink: 0;
  background-color: ${surfaceBackground};

  ${({ theme }) => theme.breakpoints.up('sm')} {
    padding: 24px 24px 20px;
  }

  ${({ theme }) => theme.breakpoints.up('md')} {
    padding: 32px 32px 24px;
  }
`;

/** Spence logo under the stepper — same placement on all 3 onboarding steps. */
export const OnboardingLogo = styled('div')`
  display: flex;
  align-items: center;
  margin-top: 41px;

  img {
    height: auto;
    max-width: 120px;
    display: block;
  }

  ${({ theme }) => theme.breakpoints.up('sm')} {
    img {
      max-width: 140px;
    }
  }

  ${({ theme }) => theme.breakpoints.up('md')} {
    img {
      max-width: 160px;
    }
  }
`;
